module.exports = __webpack_public_path__ + "img/globe-icon.b1b5e102.svg";